module.exports = __webpack_public_path__ + "img/speak4.bbbafad8.png";